import { useNavigate, useParams } from 'react-router-dom';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import IGridComponent from '../../../components/grid/i-grid.component';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { deletePojo, getPOJOByLinkId, getPojoPrint } from '../order.services';
import { getMasterDataById } from '../../master-data/masterdata.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import { formatTo0Decimal, isEmpty, isEmptyArray } from '../../common/util.services';
import PDFPojoComponent from './pdf-pojo.component';
import PrintIcon from '@mui/icons-material/Print';

const POJOComponent = (props: any) => {
  const navigate = useNavigate();
  const appContext = useContext(AppContext);
  const params = useParams();
  const rows: GridRowsProp = [];
  const [pojoData, setPOJOData] = useState(rows); 
  const linkId = params.linkId;
  const [loading, setLoading] = useState(true);
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [title, setTitle] = useState('');
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const columns: GridColDef[] = [
    { 
      field: 'pojoCode', headerName: 'Code', filterable: false, sortable: false, editable: false, width: 115,
      renderCell: (params) => { return <div className="cell-link"
      onClick={() => { openPOJOPage(params.row) }}> {params.row.pojoCode}</div> }
    },
    { 
      field: 'inputType', headerName: 'I/P Type', filterable: false, sortable: false, editable: false, width: 80
    },
    { 
      field: 'inputName', headerName: 'Input', filterable: false, sortable: false, editable: false, width: 100
    },
    { 
      field: 'inputCode', headerName: 'IP Code', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params) => { return <div className={'NA' === params.row.inputCode ? "" : "cell-link"}
      onClick={() => { openSpecsPopup(params.row.inputCode, params.row.inputId) }}>{params.row.inputCode}</div>}
    },
    { 
      field: 'outputDesc', headerName: 'Output Desc', filterable: false, sortable: false, editable: false, width: 130
    },
    { 
      field: 'outputQuantity', headerName: 'Required O/P', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params) => formatTo0Decimal(params.row.outputQuantity) + ' ' + params.row.outputUom
    },
    { 
      field: 'plannedOutput', headerName: 'Planned O/P', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params) => formatTo0Decimal(params.row.plannedOutput) + ' ' + params.row.outputUom
    },
    { 
      field: 'challanPlanned', headerName: 'Issued O/P', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => 'Purchase Order' === params.row.pojoType ? 'NA' : 
                              formatTo0Decimal(params.row.challanPlanned) + ' ' + params.row.outputUom
    },
    { 
      field: 'challanPending', headerName: 'Pending O/P', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => 'Purchase Order' === params.row.pojoType ? 'NA' : 
                              formatTo0Decimal(params.row.challanPending) + ' ' + params.row.outputUom,
      cellClassName: (params) => {return 'Purchase Order' === params.row.pojoType || 
                                         0 === params.row.challanPending  ? '' : 'AdDiffN'}
    },
    { 
      field: 'cost', headerName: 'Cost', filterable: false, sortable: false, editable: false, width: 110,
      valueFormatter: (cost: any) => isEmpty(cost) ? 'NA' : '₹ ' + formatTo0Decimal(cost)
    },
    { 
      field: 'challan', headerName: 'Challan', filterable: false, sortable: false, editable: false, width: 115,
      renderCell: (params) => { return <div className={'NA' !== params.row.challan ? "cell-link" : '' }
      onClick={() => { openChallanPage(params.row) }}> {params.row.challan}</div> }
    },
    { 
      field: 'print', headerName: 'Print', filterable: false, sortable: false, editable: false, width: 20,
      renderCell: (params) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
          <PrintIcon fontSize='small' color="secondary"/>
        </div>
      )
    }
  ];

  const openPOJOPage = (row: any) => {
    navigate('/order/pojo/' + row.rowId, {state: {inputs: null, challan: row.challan}});
  }

  const openChallanPage = (row: any) => {
    if('NA' !== row.challan) {
      navigate('/order/challan/list/' + row.rowId);
    }
  }

  const openSpecsPopup = (inputCode: any, inputId: any) => {
    if('NA' !== inputCode) {
      setLoading(true);
      getMasterDataById(inputId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setSpecsData(response.data);
          setOpenSpecs(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  const createChallan = () => {
    if(isEmptyArray(selectedRows)) {
      appContext.setDialogMessage('Select a row.');
      return;
    }

    if(selectedRows[0].qltyParams <= 0) {
      appContext.setDialogMessage('Set input quality parameters in the order page.');
      return;
    }

    navigate('/order/challan/new', {state: {pojoData: selectedRows[0], stockModel: {}}});
  }

  const onRowSelectionModelChange = (ids: any) => {
    const selectedIds = new Set(ids);
    const selectedRowData = pojoData.filter((row) =>
      selectedIds.has(row.rowId)
    );
    setSelectedRows(selectedRowData);
  }

  const closePrint = () => {
    setOpenPrint(false);
  }

  const deletePojoData = (row: any) => {
    if('NA' !== row.challan) {
      appContext.setDialogMessage('Challan is created. Delete the challan first.')
      return;
    } else {
      setLoading(true);
      deletePojo(row.rowId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          navigate(-1);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  const handleCellClick = (value: any) => {
    if('print' === value.field) {
      getPojoPrint(value.row.rowId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setRowData(response.data);
          setOpenPrint(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    getPOJOByLinkId(linkId, appContext,
      (response: any) => {
        setPOJOData(response.data);
        setTitle(response.data[0].pojoType);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        setLoading(false);
      });
  }, []);

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={pojoData} columns={columns} loading={loading} maxHeight={550} hideFooterPagination={true}
        showAddBtn={false} showApproveAction={false} showAction={true} showDeleteAction={true} showUpAction={false} showDownAction={false}
        getRowId={(row: any) => row.rowId} hideFooter={false} disableMultipleRowSelection={true} showEditAction={false}
        rowSelectionModelChange={onRowSelectionModelChange} showExtBtn={true} cellClick={handleCellClick} handleDeleteAction={deletePojoData}
        disableRowSelectionOnClick={true} checkboxSelection={true} extBtnText={'Create Challan'} extBtnAction={createChallan}/>
      <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
        dialogBody={<SpecsComponent data={specsData} />} />
      <IDialogComponent onClose={closePrint} open={openPrint} title='Print Pojo'
        dialogBody={<PDFPojoComponent data={rowData}/>} />
    </>
  }

  return <TitlePanel title={title + '(s)'} panelBody={getMainPanel()} />
}

export default POJOComponent;